import { isBrowser, } from "@shipt/analytics-core";
import { getContext, getAnonymousId, postWorkerMessage } from "./utils/browser";
/**
 *
 * @param event - event name
 * @param properties - event properties
 * @param options - top level event options to send in request payload (sans properties)
 */
export const track = (event, properties, options) => {
    try {
        if (!isBrowser()) {
            return;
        }
        postWorkerMessage({ options: getTrackOptions(event, properties, options) });
    }
    catch (e) {
        console.error(e);
    }
};
export function getTrackOptions(event, properties, options) {
    return {
        ...options,
        context: getContext(options === null || options === void 0 ? void 0 : options.context),
        anonymousId: getAnonymousId(),
        type: "track",
        event,
        properties,
    };
}
